<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="文件名称：" prop="file_name">
                    <el-input v-model.trim="form.file_name" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="padding-right: 16px;">
                <el-button type="primary" size="small" @click="uplaod">上传文件</el-button>
            </div>
        </div>
        <el-table :data="tableList" size="mini">
            <el-table-column label="id">
                <template v-slot="scope">
                    <span>{{ scope.row.id }}</span>
                </template>
            </el-table-column>
            <el-table-column label="文件名称">
                <template v-slot="scope">
                    <span>{{ scope.row.file_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="文件大小">
                <template v-slot="scope">
                    <span>{{ scope.row.file_size }}</span>
                </template>
            </el-table-column>
            <el-table-column label="MIME类型">
                <template v-slot="scope">
                    <span>{{ scope.row.file_type }}</span>
                </template>
            </el-table-column>
            <el-table-column label="上传人uid">
                <template v-slot="scope">
                    <span>{{ scope.row.upload_by }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态">
                <template v-slot="scope">
                    <span>{{ scope.row.status === 1 ? '正常' : scope.row.status === 2 ? '已删除' : '' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="备注">
                <template v-slot="scope">
                    <span>{{ scope.row.remark }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="180px" prop="created_at">
                <template v-slot="scope">
                    <span>{{ scope.row.created_at }}</span>
                </template>
            </el-table-column>
            <el-table-column label="更新时间(+8)" width="180px" prop="updated_at">
                <template v-slot="scope">
                    <span>{{ scope.row.updated_at }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="260px">
                <template v-slot="scope">
                    <el-button type="primary" size="mini" style="margin-left: 10px;"
                        @click="preview(scope.row)">预览</el-button>
                    <el-button type="danger" size="mini" style="margin-left: 10px;"
                        @click="del(scope.row)">删除</el-button>
                    <el-button type="primary" size="mini" style="margin-left: 10px;"
                        @click="copy(scope.row)">复制</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>

        <!-- 上传文件弹窗 -->
        <el-dialog v-model="uploadDialogVisible" title="上传文件" width="800px" :close-on-click-modal="false">
            <el-form ref="uploadFormRef" :model="uploadForm" :rules="uploadRules" label-width="100px" size="small">
                <el-form-item label="选择文件：" required>
                    <el-upload ref="uploadRef" v-model:file-list="uploadFileList" :auto-upload="false"
                        :on-change="handleFileChange" :on-exceed="handleExceed" :limit="1" action="" drag
                        :show-file-list="true" :disabled="uploadLoading">
                        <i class="el-icon-upload" v-if="!uploadLoading"></i>
                        <i class="el-icon-loading" v-if="uploadLoading"></i>
                        <div class="el-upload__text" v-if="!uploadLoading">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__text" v-if="uploadLoading">文件上传中，请稍候...</div>
                        <template #tip>
                            <div class="el-upload__tip" v-if="!uploadLoading">请选择要上传的文件，文件名将自动使用原始文件名。可以重新选择文件替换当前文件。
                            </div>
                            <div class="el-upload__tip" v-if="uploadLoading" style="color: #409EFF;">正在上传文件到服务器，请耐心等待...
                            </div>
                        </template>
                    </el-upload>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input v-model="uploadForm.remark" type="textarea" :rows="3" placeholder="请输入备注信息" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelUpload" :disabled="uploadLoading">取消</el-button>
                    <el-button type="primary" @click="confirmUpload" :loading="uploadLoading" :disabled="uploadLoading">
                        {{ uploadLoading ? '上传中...' : '确定' }}
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import util from '../../../../util/util'
import api from '../../../../axios/api'
import dayjs from 'dayjs'
import axios from 'axios'

export default {
    setup() {
        const form = reactive({
            file_name: ''
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const tableList = ref([])
        const ruleList = ref([])
        const uploadDialogVisible = ref(false)
        const uploadForm = reactive({
            remark: ''
        })
        const uploadFormRef = ref()
        const uploadFileList = ref([])
        const uploadRules = reactive({})
        const uploadRef = ref()
        const uploadLoading = ref(false)

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const onSearch = async () => {
            const res = await api.ContentManageFileList({
                ...toRaw(form),
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { list, page_info } = res.data.data
                tableList.value = list
                pagination.total = page_info.total
                pagination.page = page_info.current_page
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        // 上传文件
        const uplaod = () => {
            console.log('打开上传弹窗')
            uploadDialogVisible.value = true
            uploadForm.remark = ''
            uploadFileList.value = []
            uploadLoading.value = false
            console.log('初始化文件列表:', uploadFileList.value)
        }

        // 预览文件
        const preview = (row) => {
            if (row.s3_url) {
                window.open(row.s3_url, '_blank')
            } else {
                ElMessage.warning('该文件没有预览地址')
            }
        }

        const copy = async (row) => {
            try {
                await navigator.clipboard.writeText(row.s3_url)
                ElMessage.success('复制成功')
            } catch (error) {
                console.error(error.message)
            }
        }

        // 文件上传处理
        const handleFileChange = (file, fileList) => {
            const { raw } = file
            if (!raw) return

            console.log('文件选择:', file, fileList)

            // 开始上传，设置loading状态
            uploadLoading.value = true

            util.getFileMD5(raw, async md5 => {
                const params = {
                    key_action: 'content_page',
                    key_md5: md5,
                    key_type: 'display',
                    key_suffix: raw.name.split('.').pop(),
                    content_length: raw.size,
                    content_type: raw.type
                }

                try {
                    const res = await api.S3push(params)
                    if (res.data.code == 200) {
                        await fileUpload(raw, res.data.data.put_url)

                        // 准备文件创建参数，直接使用原始文件名
                        const createParams = {
                            file_name: raw.name,
                            file_size: raw.size,
                            file_extend: raw.name.split('.').pop(),
                            file_type: raw.type,
                            key_md5: md5,
                            s3_key: res.data.data.key,
                            s3_url: res.data.data.get_url,
                            remark: uploadForm.remark
                        }

                        // 保存文件信息到当前文件对象
                        file.uploadParams = createParams
                        console.log('文件处理完成:', createParams)
                        uploadFileList.value = [file]

                        // 上传完成，取消loading状态
                        uploadLoading.value = false
                        ElMessage.success('文件上传完成，可以点击确定保存')

                    } else {
                        ElMessage.error('预签名失败: ' + res.data.msg)
                        uploadLoading.value = false
                    }
                } catch (error) {
                    ElMessage.error('上传失败: ' + error.message)
                    uploadLoading.value = false
                }
            })
        }

        // 文件上传到S3
        const fileUpload = async (raw, put_url) => {
            try {
                const config = {
                    headers: {
                        'Content-Type': raw.type,
                        'X-Amz-Acl': 'public-read',
                        'X-Amz-Server-Side-Encryption': "AES256"
                    }
                }
                const urlReg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/
                const url = '/aws' + put_url.split(urlReg.exec(put_url)[0])[1]
                const res = await axios.put(url, raw, config)
                if (res.status !== 200) {
                    throw new Error('上传到S3失败')
                }
            } catch (error) {
                throw new Error('上传失败: ' + error.message)
            }
        }

        // 确认上传
        const confirmUpload = async () => {
            console.log('确认上传，文件列表:', uploadFileList.value)

            if (uploadLoading.value) {
                ElMessage.warning('文件正在上传中，请稍后...')
                return
            }

            if (uploadFileList.value.length === 0) {
                ElMessage.error('请选择要上传的文件')
                return
            }

            const file = uploadFileList.value[0]
            console.log('选中的文件:', file)

            if (!file.uploadParams) {
                ElMessage.error('文件还在处理中，请稍后')
                return
            }

            // 更新备注信息
            file.uploadParams.remark = uploadForm.remark
            console.log('准备提交的参数:', file.uploadParams)

            try {
                const res = await api.ContentManageFileCreate(file.uploadParams)
                if (res.data.code === 200) {
                    ElMessage.success('上传成功')
                    uploadDialogVisible.value = false
                    onSearch() // 刷新列表
                } else {
                    ElMessage.error('保存失败: ' + res.data.msg)
                }
            } catch (error) {
                ElMessage.error('保存失败: ' + error.message)
            }
        }

        // 处理文件超出限制
        const handleExceed = (files) => {
            console.log('文件超出限制，替换现有文件:', files)
            uploadRef.value.clearFiles()
            const file = files[0]
            file.uid = Date.now().toString()
            uploadRef.value.handleStart(file)
        }

        // 取消上传
        const cancelUpload = () => {
            if (uploadLoading.value) {
                ElMessage.warning('文件正在上传中，请稍后再取消')
                return
            }
            uploadDialogVisible.value = false
            uploadForm.remark = ''
            uploadFileList.value = []
            uploadLoading.value = false
        }

        // 删除
        const del = (row) => {
            ElMessageBox.confirm('你确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const res = await api.ContentManageFileDelete({ id: row.id })
                    if (res.data.code == 200) {
                        ElMessage.success('删除成功')
                        onSearch()
                    } else {
                        ElMessage.error('删除失败' + res.data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    ElMessage.info('已取消删除')
                })
        }

        onMounted(() => {
            onSearch()
        })

        return {
            form,
            onSearch,
            tableList,
            formRef,
            pagination,
            handleCurrentChange,
            resetForm,
            del,
            util,
            ruleList,
            dayjs,
            uplaod,
            preview,
            copy,
            uploadDialogVisible,
            uploadForm,
            uploadFormRef,
            uploadFileList,
            uploadRules,
            handleFileChange,
            confirmUpload,
            cancelUpload,
            handleExceed,
            uploadRef,
            uploadLoading
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }
}
</style>
